import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from '@lciapps/lci-core';
import { FooterService } from '../footer-service/footer.service';

export interface TextForFooter {
  textForFooterType1: string;
  textForFooterType2: string;
  textToDisplay: string;
}
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(private router: Router,
    private route: ActivatedRoute,
    private translationService: TranslationService, private footerService: FooterService) { }
  footerType: string = '';
  contactSupportLink: string = "javascript:void(0)";
  assistanceText: TextForFooter = {
    textForFooterType1: 'Need assistance?',
    textForFooterType2: 'Still need assistance?',
    textToDisplay: 'Need assistance?'
  }
  contactSupportText: TextForFooter = {
    textForFooterType1: 'Contact Support',
    textForFooterType2: 'Call us direct at (+001) 630-468-6900',
    textToDisplay: 'Contact Support'
  }
  registrationFooter1: string = "@ 2020 Lions Clubs International. All rights reserved.";
  privacyPolicyText: string = "Privacy Policy";
  termsOfUseText: string = "Terms of Use";
  lnkPrivacyPolicy: string = '';
  lnkTermsOfUse: string = '';

  ngOnInit() {
    this.footerType = '';
    this.footerService.getFooterType.subscribe((val) => {
      this.footerType = val;
      this.initTranslations(this.footerType);
    });
  }
  initTranslations(footerType: string) {
    if (footerType === 'type1') {
      this.assistanceText.textToDisplay = "Need assistance?";
      this.contactSupportText.textToDisplay = "Contact Support";
      this.contactSupportLink = "javascript:void(0)";
      this.translationService.getTranslationValue('lblRegistrationNeedAssistance').subscribe((value) => {
        this.assistanceText.textForFooterType1 = value;
        this.assistanceText.textToDisplay = this.assistanceText.textForFooterType1;
      });
      this.translationService.getTranslationValue('lblRegistrationContactSupport1').subscribe((value) => {
        this.contactSupportText.textForFooterType1 = value;
        this.contactSupportText.textToDisplay = this.contactSupportText.textForFooterType1;
      });
    }
    else if (footerType === 'type2') {
      this.assistanceText.textToDisplay = "Still need assistance?";
      this.contactSupportText.textToDisplay = "Call us direct at (+001) 630-468-6900";
      this.contactSupportLink = "tel:+0016304686900";
      this.translationService.getTranslationValue('lblRegistrationNeedAssistance2').subscribe((value) => {
        this.assistanceText.textForFooterType2 = value;
        this.assistanceText.textToDisplay = this.assistanceText.textForFooterType2;
      });
      this.translationService.getTranslationValue('lblRegistrationCallDirectly').subscribe((value) => {
        this.contactSupportText.textForFooterType2 = value;
        this.contactSupportText.textToDisplay = this.contactSupportText.textForFooterType2;
      });
    }
    this.translationService.getTranslationValue('lblRegistrationFooter1').subscribe(val => { this.registrationFooter1 = val; });
    this.translationService.getTranslationValue('lblRegistrationPrivacyPolicy').subscribe(val => { this.privacyPolicyText = val; });
    this.translationService.getTranslationValue('lblRegistrationTermsOfUse').subscribe(val => { this.termsOfUseText = val; });
    this.translationService.getTranslationValue('lnkPrivacyPolicy').subscribe(val => { this.lnkPrivacyPolicy = val; });
    this.translationService.getTranslationValue('lnkTerms').subscribe(val => { this.lnkTermsOfUse = val; });
  }
  contactSupport() {
    this.router.navigate(['../account/contact-support'], { relativeTo: this.route });

  }
  navigateToPlayStore() {
    window.open("https://play.google.com/store/apps/details?id=org.lionsclubs.lciandroid&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1", '_blank');
  }
  navigateToAppStore() {
    window.open("https://itunes.apple.com/us/app/mylion-by-lions-clubs-international/id1240307147?mt=8", '_blank');
  }
}
